import React from 'react'
import { InputSingleMoneyValueNext } from '../../../../../../../ui/organisms/InputSingleMoneyValueNext'

export default {
  title: 'What is the total value of this project',
  next: 'projectInfo.projectFinancing',
  component: ({ currentData, onValue, ...props }) => <InputSingleMoneyValueNext data={currentData?.content} onValue={onValue} {...props} />
}